import { Button, Spin, Tooltip } from "@arco-design/web-react";
import { LocateFixed, RotateCcw } from "lucide-react";

import { useHotelMapRuntime, type HotelMapRuntime } from "../runtime";
import { HotelMapCanvas, HotelMapSearchBar } from "../ui";

/** 使用生产 runtime 的酒店地图路由页面。 */
export function HotelMapPage() {
  const runtime = useHotelMapRuntime();
  return <HotelMapPageContent runtime={runtime} />;
}

/** 使用可注入 runtime 渲染酒店地图页面内容。 */
export function HotelMapPageContent({ runtime }: { runtime: HotelMapRuntime }) {
  return (
    <main className="hotel-map-page">
      <HotelMapCanvas mount={runtime.mount} />

      {!runtime.mapReady ? (
        <div className="hotel-map-page__map-loading" aria-label="地图加载中">
          <Spin size={28} />
        </div>
      ) : null}

      <HotelMapSearchBar
        areas={runtime.areas}
        points={runtime.points}
        query={runtime.searchQuery}
        searching={runtime.searching}
        onQueryChange={runtime.setSearchQuery}
        onSelect={runtime.selectSearchItem}
      />

      {runtime.notice || runtime.error ? (
        <div className="hotel-map-page__feedback">
          {runtime.notice ? (
            <div className="hotel-map-page__notice">{runtime.notice}</div>
          ) : null}
          {runtime.error ? (
            <div className="hotel-map-page__error" role="alert">
              <span>{runtime.error}</span>
              <Button
                size="mini"
                type="text"
                icon={<RotateCcw size={14} />}
                onClick={() => void runtime.retry()}
              >
                重试
              </Button>
            </div>
          ) : null}
        </div>
      ) : null}

      {runtime.loadingPois ? (
        <div className="hotel-map-page__poi-loading">
          <Spin size={14} />
          <span>正在加载酒店</span>
        </div>
      ) : null}

      <div className="hotel-map-page__locate-control">
        <Tooltip content="回到当前位置" position="left">
          <Button
            aria-label="回到当前位置"
            icon={<LocateFixed size={20} />}
            loading={runtime.locatingCurrentPosition}
            disabled={!runtime.mapReady || runtime.locatingCurrentPosition}
            onClick={() => void runtime.goToCurrentPosition()}
          />
        </Tooltip>
      </div>
    </main>
  );
}
